import {
    IAssertionDescriptorModel,
    IEntityAssertionModel,
} from '../../interfaces/IAssertionDescriptor';

import { EntityTypes } from '../../utilities/Constants';
import { IValidation } from '../../interfaces/IError';
import { Modal } from 'react-bootstrap';

export interface IEditNarrativeModalMetaInfo {
    title: string;
    name: string;
}

export interface IEditNarrativeModalProps {
    assertionDescriptors: IAssertionDescriptorModel[];
    entityAssertion: IEntityAssertionModel;
    onCancel: () => void;
    onClear: () => void;
    onFinalizeChange: (
        modifiedAssertions: IEntityAssertionModel[],
        metaInfo?: IEditNarrativeModalMetaInfo
    ) => void;
    onNarrativeFieldTextChange: (
        event:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => void;
    validation: IValidation;
    metaInfo?: IEditNarrativeModalMetaInfo;
}

export function EditNarrativeModal(props: IEditNarrativeModalProps) {
    const foundAD = props?.assertionDescriptors.find(
        (ad) => ad.guid === props.entityAssertion?.assertionDescriptorGuid
    );

    return (
        <Modal centered show={true}  backdrop>
            <Modal.Header>
                <Modal.Title>{props.metaInfo?.title ?? foundAD?.displayName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span className="text-danger">{props.validation.model}</span>
                </div>
                <div>
                    <textarea
                        className="form-control"
                        value={props.entityAssertion?.textValue}
                        name={props.entityAssertion?.assertionDescriptorGuid}
                        rows={10}
                        onChange={props.onNarrativeFieldTextChange}
                    />
                </div>
                <Modal.Footer>
                    <button className="btn btn-default" onClick={props.onClear}>
                        Clear
                    </button>
                    <button className="btn btn-default" onClick={props.onCancel}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-black"
                        onClick={() =>
                            props.entityAssertion
                                ? props.onFinalizeChange([props.entityAssertion], props.metaInfo)
                                : {}
                        }
                    >
                        OK
                    </button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
}

export function EditNarrativeModalExecutionPlan(props: IEditNarrativeModalProps) {
    const foundAD = props.assertionDescriptors.find(
        (ad) => ad.guid === props.entityAssertion.assertionDescriptorGuid
    );

    if (!foundAD) {
        return null;
    }

    return (
        <Modal centered show={true} backdrop>
            <Modal.Header>
                <Modal.Title>{foundAD.displayName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span className="text-danger">{props.validation.model}</span>
                </div>
                <div>
                    <textarea
                        className="form-control"
                        value={props.entityAssertion.textValue}
                        name={props.entityAssertion.assertionDescriptorGuid}
                        rows={
                            props.entityAssertion.entityType.id === EntityTypes.OperatingMechanism
                                ? 4
                                : 15
                        }
                        maxLength={
                            props.entityAssertion.entityType.id === EntityTypes.OperatingMechanism
                                ? 300
                                : -1
                        }
                        onChange={props.onNarrativeFieldTextChange}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-default" onClick={props.onClear}>
                    Clear
                </button>
                <button className="btn btn-default" onClick={props.onCancel}>
                    Cancel
                </button>
                <button
                    className="btn btn-orange"
                    onClick={() =>
                        props.entityAssertion ? props.onFinalizeChange([props.entityAssertion]) : {}
                    }
                >
                    OK
                </button>
            </Modal.Footer>
        </Modal>
    );
}
